// extracted by mini-css-extract-plugin
export default {"container":"HZ-z","heading":"IZ-z","links":"JZ-z","copy":"KZ-z","subCopy":"LZ-z","linksLeft":"MZ-z","linksCenter":"NZ-z","linksRight":"OZ-z","link":"PZ-z","onlyLink":"QZ-z"};